import { truncate } from 'lodash';

const STUDENT_NAME_LENGTH_LIMIT = 14;

export const limitStudentNameLength = (name: string) => {
  return truncate(name, {
    length: STUDENT_NAME_LENGTH_LIMIT,
  });
};
